export default __webpack_public_path__ + "static/media/upload_cloud_success.85078496.svg";